import { useState, useEffect } from "react";
import { FaqCategory } from "../../Types";
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { useGlobalContext } from "../../Context/GlobalContext";

const FAQ = () => {
    const { dbManager } = useGlobalContext();

    const [categories, setCategories] = useState<FaqCategory[]>([]);
    const [expanded, setExpanded] = useState<string | false>(false);

    useEffect(() => {
        const getFaqs = async () => {
            mapFaqs(await dbManager.request('/items/faqs'));
        }
        getFaqs();
    }, [dbManager]);

    const handleChange = (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

    const mapFaqs = (faqs: any) => {
        const categories: FaqCategory[] = [];
        faqs.forEach((faq: any) => {
            const category = categories.find((category) => category.title === faq.category);
            if (category) {
                category.rows.push({ question: faq.question, answer: faq.answer });
            } else {
                categories.push({ title: faq.category, rows: [{ question: faq.question, answer: faq.answer }] });
            }
        });
        setCategories(categories);
    }

    return (
        <div className="faq">
            <div style={{ marginBottom: '50px', fontSize: '1.2vw' }}>FAQ</div>
            <div className="faq-wrapper">
                {categories.map((category) => (
                    <div className="faq-category" key={category.title}>
                        <div className="category-title">{category.title}</div>
                        {category.rows.map((row) => (
                            <Accordion 
                                expanded={expanded === row.question} 
                                onChange={handleChange(row.question)}
                                className="faq-accordion"
                                key={row.question}
                            >
                                <AccordionSummary
                                    expandIcon={
                                        expanded !== row.question 
                                        ? <AddIcon className="theme-color"/> 
                                        : <RemoveIcon className="theme-color"/>
                                    }
                                >
                                    <div className="faq-question">{row.question}</div>
                                </AccordionSummary>
                                <AccordionDetails>         
                                    <div className="faq-answer">{row.answer}</div>             
                                </AccordionDetails>
                            </Accordion>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
}

export default FAQ;